import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { ReadonlyAccessWidget } from '../../readonly-access/readonly-access.widget';
import { AccApplicationDialogDataService } from '../acc-application-dialog-data.service';
import { getSetup } from './grid/get-setup';

export interface AlignedAccelerator {
	accId: number,
	accName: string,
	facilitatorName: string | undefined,
	seatOffered: boolean,
	canAttend: boolean,
	availableSeatCount: number,
	seatsOffered: number,
	seatsAccepted: number,
	gravityMiles: number,
	meetingLocalDisplayText: string,
	meetingAcceleratorDisplayText: string,
	languageId?: number,
	updatedUTC: number,
}

@Component({
	selector: 'application-dialog-aligned-accelerators-part',
	standalone: true,
	imports: [GridContentWidget, ReadonlyAccessWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './aligned-accelerators.part.html',
})
export class ApplicationDialogAlignedAcceleratorsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	public accApplDialogDataService = inject(AccApplicationDialogDataService);
	private app = this.accApplDialogDataService.app;

	public setup = getSetup(this.util, this.accApplDialogDataService);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.accApplDialogDataService.isReadonly() ? 45 : 0));

	public alignedAccelerators = computed<AlignedAccelerator[]>(() => {
		const accApplication = this.accApplDialogDataService.dialogData()?.details;
		if (!accApplication) return [];

		const accsMap = new Map(this.accApplDialogDataService.accWithScheduleSlots().map(acc => [acc.accId, acc]));

		const alignedAccs: AlignedAccelerator[] = (this.accApplDialogDataService.dialogData()?.alignedAccelerators ?? []).map(alignedAcc => {
			const acc = accsMap.get(alignedAcc.accId);
			return {
				accId: alignedAcc.accId,
				accName: acc?.name ?? '',
				facilitatorName: this.app.getStaffNameById(acc?.facilitatorStaffId),
				seatOffered: accApplication.offeredSeatAccId == alignedAcc.accId,
				seatsOffered: alignedAcc.seatsOffered,
				seatsAccepted: alignedAcc.seatsAccepted,
				availableSeatCount: alignedAcc.availableSeatCount,
				canAttend: acc?.applicantSelectedAccSlot ?? false,
				gravityMiles: alignedAcc.gravityMiles,
				meetingLocalDisplayText: acc?.meetingLocalDisplayText ?? '',
				meetingAcceleratorDisplayText: acc?.meetingAcceleratorDisplayText ?? '',
				languageId: acc?.languageId,
				updatedUTC: Date.now(),
			}
		}) ?? [];

		return alignedAccs;
	});



}